import { useGlobalStore } from '../../stores/globalStore';

/** The facility-wide assessment list. */
export const ASSESSMENTS_ROUTE = '/assessments';

/**
 * True when the facility's UseAssessment setting is off. The desktop then hides
 * Assessments (frmDietech_Resident_DataGrid_V2.vb:955-975), so the website hides
 * the resident's Assessments section (residentSectionAccess.ts), the facility
 * list and every link to it. Unknown settings (not loaded yet) hide nothing.
 */
export function useAssessmentsOff(): boolean {
  return useGlobalStore((s) => s.facilitySettings?.useAssessment === false);
}

/** `items` without the ones that open the assessment list when assessments are off. */
export function withoutAssessmentLinks<T extends { route?: string }>(items: readonly T[], off: boolean): T[] {
  return off ? items.filter((i) => i.route !== ASSESSMENTS_ROUTE) : [...items];
}
